export default __webpack_public_path__ + "static/media/side_edit.6035ee3e.svg";